<template>
  <div class="form-group">
    <label class="label-option">
      Additional fields
      <span class="title-table-presentation-tooltip result-layout-tooltip">
        <b-button
          v-tooltip="'You can collect additional info from each response such as the responder\'s name, team name, etc.'"
          class="tooltip-btn"
        />
        <i class="fas fa-question-circle" />
      </span>
    </label>

    <div v-if="$store.state.slideActive.additionalFields">
      <AdditionalFieldsForm
        @updateAdditionalFields="updateAdditionalFields"
        :limitFields="4"
        type="openEnded"
      />
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import Socket from '@/socket'
import Config from '@/config'
import AdditionalFieldsForm from '@/components-v2/presentation-editor/side-right/AdditionalFieldsForm.vue'

export default {
  components: {
    AdditionalFieldsForm,
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    updateAdditionalFields() {
      this.updateSlideActiveAction(this.$store.state.slideActive)
      const payload = {
        additionalFields: JSON.stringify(
          this.$store.state.slideActive.additionalFields,
        ),
        socketId: Socket.getSocketId(),
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        presenting: this.$store.getters.isPresenting,
      }
      const slideId = this.$store.state.slideActive.id

      this.$http.put(Config.api.updateSlide + slideId, payload).then(
        () => {
          const index = this.$store.state.presentation.slides.findIndex((item) => {
            return item.id === slideId
          })

          if (index !== -1) {
            this.$store.state.presentation.slides[
              index
            ].additionalFields = JSON.parse(payload.additionalFields)
          }
        },
        () => {},
      )
    },
  },
}
</script>
